// extracted by mini-css-extract-plugin
export default {"container":"yE-z","innerContainer":"zE-z","multipleLines":"AE-z","heading":"BE-z","content":"CE-z","linkColor":"DE-z"};